import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '@/api/auth';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('EMAIL REQUIRED');
      return;
    }

    setLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSubmitted(true);
    } catch {
      setError('SOMETHING WENT WRONG. PLEASE TRY AGAIN.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-mono-950 flex items-center justify-center py-12 px-4">
      <div className="max-w-sm w-full">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-mono-100 tracking-[0.4em] font-orbitron">ARGOS</h1>
          <p className="text-mono-500 text-xs tracking-widest mt-2 font-orbitron">PASSWORD RESET</p>
          <div className="mt-8 h-px bg-mono-800" />
        </div>

        {submitted ? (
          <div className="text-center space-y-6">
            <div className="border border-cyan-500/30 bg-cyan-500/10 p-6">
              <p className="text-xs text-cyan-400 tracking-wider mb-2">CHECK YOUR EMAIL</p>
              <p className="text-[11px] text-mono-400 leading-relaxed">
                If an account exists for <span className="text-mono-200">{email}</span>,
                we've sent a link to reset your password.
              </p>
            </div>
            <Link
              to="/login"
              className="inline-block text-[10px] text-cyan-400 hover:text-cyan-300 tracking-wider"
            >
              BACK TO LOGIN
            </Link>
          </div>
        ) : (
          <>
            <p className="text-[11px] text-mono-400 text-center mb-8 leading-relaxed">
              Enter your email address and we'll send you a link to reset your password.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="border border-red-500/30 bg-red-500/10 p-3 text-center">
                  <p className="text-xs text-red-400 tracking-wider">{error}</p>
                </div>
              )}

              <div>
                <label className="block text-[10px] text-mono-500 tracking-widest mb-2">
                  EMAIL
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 bg-mono-900 border border-mono-700 text-mono-200 text-sm focus:border-cyan-500/50 focus:outline-none tracking-wide"
                  placeholder="you@company.com"
                  autoFocus
                  autoComplete="email"
                />
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 border border-cyan-500 bg-cyan-500 text-black text-xs font-medium tracking-widest hover:bg-cyan-400 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? 'SENDING...' : 'SEND RESET LINK'}
                </button>
              </div>
            </form>

            <div className="mt-8 text-center">
              <Link
                to="/login"
                className="text-[10px] text-mono-500 hover:text-mono-300 tracking-wider"
              >
                BACK TO LOGIN
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
